import { render, staticRenderFns } from "./MedicinesTypeDelete.vue?vue&type=template&id=14387237&scoped=true&"
import script from "./MedicinesTypeDelete.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14387237",
  null
  
)

export default component.exports